import useEmblaCarousel from "embla-carousel-react";
import { usePrevNextButtons } from "../../../../../../helpers/hooks/usePrevNextButtons.ts";
import {
  NextButton,
  PrevButton,
} from "../../../../../discoverCommunities/components/traditionalView/components/personaDisclosureFilter/components/carouselArrowsBtn/CarouselArrowsBtn.tsx";

const INTEREST_LIST = [
  "Outdoor Enthusiast",
  "Trail Running",
  "Travel Families",
];
export const InterestAudience = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel({});
  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);
  return (
    <div className="rounded-lg bg-primary-25 border border-primary-600/14 overflow-hidden">
      <div className="pt-2 px-4 flex items-center gap-2">
        <p className="typography-body-sm text-monochrome-900">
          Interest group(s)
        </p>
        <p className="typography-body-xs text-monochrome-500">
          {INTEREST_LIST.length} total
        </p>
      </div>
      <div className="px-6">
        <div className="embla relative" ref={emblaRef}>
          <div className="embla__container flex gap-3 py-2">
            {INTEREST_LIST.map((interest, index) => (
              <div
                className="embla__slide"
                key={`interest-media-plan-${index}-${interest}`}
              >
                <div className="w-[210px] p-2 bg-white border border-primary-600/14 rounded-lg grid grid-cols-[40px_1fr] items-center gap-3">
                  <p className="typography-body-sm text-primary-500 whitespace-nowrap">
                    {interest}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <PrevButton
            onClick={onPrevButtonClick}
            disabled={prevBtnDisabled}
            className="w-6 h-full  group absolute top-0 left-0 overflow-y-hidden -translate-x-full z-10 bg-primary-25"
          />
          <NextButton
            onClick={onNextButtonClick}
            disabled={nextBtnDisabled}
            className="w-6 h-full group absolute top-0 right-0 overflow-y-hidden z-10 translate-x-full bg-primary-25"
          />
        </div>
      </div>
    </div>
  );
};
